import { motion } from 'motion/react'
import type { AnswerInputProps } from '../QuestionRenderer'

const emoji = ['😡', '😕', '😐', '😊', '😍']

export function RatingInput({ question, value, onChange, onSubmit }: AnswerInputProps<number>) {
  const steps = Number(question.settings.steps ?? 5)
  const style = question.settings.style ?? 'number'

  function label(index: number) {
    if (style === 'stars') return '★'
    if (style === 'hearts') return '♥'
    if (style === 'emoji') return emoji[Math.min(index - 1, emoji.length - 1)]
    return index
  }

  return (
    <div>
      <div className="flex flex-wrap" style={{ gap: 'var(--form-answer-gap,0.875rem)' }}>
        {Array.from({ length: steps }, (_, index) => index + 1).map((score) => (
          <motion.button
            key={score}
            type="button"
            whileTap={{ scale: 1.25 }}
            onClick={() => {
              onChange(score)
              window.setTimeout(onSubmit, 120)
            }}
            className={`grid size-12 place-items-center rounded-md border text-lg font-semibold ${
              value && score <= value ? 'border-[var(--form-accent,#6366F1)]' : 'border-slate-200'
            }`}
            style={{
              background:
                value && score <= value
                  ? 'color-mix(in srgb, var(--form-accent,#6366F1) 16%, transparent)'
                  : 'color-mix(in srgb, var(--form-bg,#F8FAFC) 86%, white)',
              borderColor:
                value && score <= value
                  ? 'var(--form-accent,#6366F1)'
                  : 'color-mix(in srgb, var(--form-accent,#6366F1) 24%, transparent)',
              borderRadius: 'var(--form-radius,8px)',
              color:
                value && score <= value
                  ? 'var(--form-accent,#6366F1)'
                  : 'var(--form-answer,#334155)',
              fontFamily: 'var(--form-body-font,var(--form-font,Geist))',
              fontSize: 'var(--form-body-size,1.125rem)',
            }}
          >
            {label(score)}
          </motion.button>
        ))}
      </div>
      <div
        className="mt-3 flex justify-between gap-4 text-sm"
        style={{
          color: 'var(--form-answer,#64748B)',
          fontFamily: 'var(--form-body-font,var(--form-font,Geist))',
          fontSize: 'var(--form-meta-size,0.9375rem)',
        }}
      >
        <span>{question.settings.startLabel}</span>
        <span>{question.settings.endLabel}</span>
      </div>
    </div>
  )
}
